import Vue from 'vue';

export const formatDataEvents = data => data.map((item) => {
  const dts = item[0].dates;
  const dates = Object.keys(dts).map((key) => {
    const days = {};
    const arrd = Object.keys(dts[key]).map((keyh) => {
      const types = dts[key][keyh];
      types.map((type) => {
        if (type.type === 'venue') {
          Vue.set(type, 'value', '');
        } else {
          const max = type.maxQuantityPerOrder > 1 ? 2 : 1;
          Vue.set(type, 'value', max);
        }
        return type;
      });
      return {
        hour: keyh,
        types,
      };
    });
    days.day = key;
    days.hours = arrd;
    return days;
  });
  // eslint-disable-next-line
  item[0].dates = dates;
  Vue.set(item[0], 'showInfo', false);
  return item[0];
});

export default {};
